import { takeLatest } from 'redux-saga/effects';
import {
	getJobPostListSuccess, getJobPostListFail,
	getJobPostDetailsSuccess, getJobPostDetailsFail,
} from './jobPostState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recruitment/job-posts');
const redirectData = {route:'/console/job-roles', mode: 'list', recordId:0 };
const modelName = 'Job Post';
const modelId = 'jpo_id';

function* getJobPostList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getJobPostListSuccess, 
		getJobPostListFail, null, null, LOADING_MSG);
}

function* getJobPostDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getJobPostDetailsSuccess, 
		getJobPostDetailsFail, 
		null, null, LOADING_MSG);		
}

function* doJobPostCreate(data){
	const { jrr_id } = data.payload;
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getJobPostDetailsSuccess, 
		getJobPostDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, route:`/console/job-role-requests/${jrr_id}/view` },
		SAVING_MSG);
}

function* doJobPostUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getJobPostDetailsSuccess, 
		getJobPostDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doJobPostDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getJobPostDetailsSuccess, 
		getJobPostDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* jobPostSaga() {
	yield takeLatest('jobPost/getJobPostList', getJobPostList);
	yield takeLatest('jobPost/getJobPostDetails', getJobPostDetails);
	yield takeLatest('jobPost/doJobPostCreate', doJobPostCreate);
	yield takeLatest('jobPost/doJobPostUpdate', doJobPostUpdate);
	yield takeLatest('jobPost/doJobPostDelete', doJobPostDelete); 
}

export default jobPostSaga;
